<template>
  <div class="d-flex flex-column fill-height background pa-5">
    <div class="text-h6">Dienst "{{ dutyNameDetails }}"</div>
    <div class="d-flex">
      <div style="width: 200px" class="mt-3 mr-5 caption">
        Die nebenstehenden Dienststücke wurden manuell erfasst. Farblich markiert ist das Teilstück, für die aktuelle Zeile.
      </div>
      <div style="width: 500px">
        <div v-if="selectedDutyParts" class="d-flex col-12 col-sm-6 flex-column align-start">
          <table class="table text-left caption">
            <thead>
              <th class="pr-4">Linie/Kurs</th>
              <th class="pr-4">von</th>
              <th class="pr-4">bis</th>

              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </thead>
            <tbody class="text-left">
              <tr v-for="(da, ind) in selectedDutyParts" :key="ind">
                <template v-if="da.fromMinutesAfterMidnight">
                  <td class="text-left">
                    <div v-if="da.line">{{ da.line }}</div>
                  </td>

                  <td>
                    <div class="outlined-box" :style="getColor(ind)">{{ toTime(da.fromMinutesAfterMidnight, da) }} {{ da.fromLoc }}</div>
                  </td>

                  <td>
                    <div class="outlined-box" :style="getColor(ind)">{{ toTime(da.toMinutesAfterMidnight, da) }} {{ da.toLoc }}</div>
                  </td>

                  <td class="px-3">
                    <div v-if="da.activityShortname === 'Umlaufstück'">Umlaufstück</div>
                    <div v-else>{{ da.activityShortname }}</div>
                  </td>
                  <td>{{ da.longName }}</td>
                  <td>{{ da.activityLongname }}</td>
                  <td>{{ da.fzgNummer || da.daFzgNummer }}</td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import wsMixin from '@/modules/customerVbzWorksheet/wsMixin';
import dateUtil from '@/common/dateUtils';

export default {
  name: 'DutyPartsOwnDataView',
  mixins: [wsMixin],
  props: {
    dutySelection: {
      type: Object,
      default: () => {
        return {};
      },
    },
    dutyNameDetails: String,
  },
  mounted() {
    console.debug('dutySelection', JSON.stringify(this.dutySelection, null, 2));
  },

  data() {
    return {
      dutyActivities_: this.dutyActivities,
    };
  },
  computed: {
    resolvedDutyActivities() {
      return this.dutySelection.resolvedDutyActivities;
    },
    selectedDutyParts() {
      return this.dutySelection.selectedDutyParts;
    },
    dutySelectionPart() {
      return this.dutySelection.dutySelectionPart;
    },
  },
  methods: {
    getColor(index) {
      if (index === this.dutySelectionPart) {
        return { background: this.colorPalette[0] };
      }
      return {};
    },
    toTime(minutesAfterMidnight, da) {
      let dateString = da.day ? this.reformatDateIsoStringAsYYYYMMDD(da.day) : '';
      return dateUtil.getTimeFromMinutesAfterMidnight('24+hh:mm', minutesAfterMidnight, dateString);
    },
  },
};
</script>
<style scoped>
.outlined-box {
  border-radius: 6px;
  width: 140px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.theme--light .outlined-box {
  border: 1px solid #d0d0d0;
}
.theme--dark .outlined-box {
  border: 1px solid #505050;
}
</style>
